// import React, { useState, useEffect } from 'react';
// import { Box, Typography, Pagination } from '@mui/material';
// import { useSelector } from 'react-redux';
// import { selectUser } from '../../../Commonlibs/userSlice';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// // Import assets
// import bedIcon from '../../../assets/squarefeet.png';
// import bathIcon from '../../../assets/baths.png';
// import areaIcon from '../../../assets/feet.png';
// import saveIcon from '../../../assets/savep.png';
// import shareIcon from '../../../assets/sharep.png';
// // Import loader
// import Loader from '../../../Loader/Loader';

// const PropertiesSearched = () => {
//   const [properties, setProperties] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Pagination states
//   const [page, setPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(0);
//   const itemsPerPage = 3; // Show 3 properties per page

//   const navigate = useNavigate();
//   const user = useSelector(selectUser);
  
//   useEffect(() => {
//     const fetchSearchedProperties = async () => {
//       try {
//         setLoading(true);
//         const buyer_id = user?.id || 2;
       
//         // Get all properties at once
//         const response = await axios.get(
//           `https://propertydealstalk.com/api/buyerAnalytics/getBuyerDashboardPropertiesByType?buyer_id=${buyer_id}&type=recently_searched`
//         );
       
//         if (response.data.statusCode === 200 && response.data.status === "SUCCESS") {
//           const allProperties = response.data.result || [];
//           setProperties(allProperties);
          
//           // Calculate total pages based on all properties
//           const calculatedPages = Math.ceil(allProperties.length / itemsPerPage);
//           setTotalPages(calculatedPages);
          
//           // Reset to first page when new data is fetched
//           setPage(1);
//         } else {
//           setError(response.data.message || "Failed to fetch properties");
//         }
//       } catch (err) {
//         setError("Error fetching searched properties");
//         console.error("Error fetching searched properties:", err);
//       } finally {
//         setLoading(false);
//       }
//     };
    
//     fetchSearchedProperties();
//   }, [user]); // Only depend on user, not page

//   // Get current page items
//   const getCurrentPageItems = () => {
//     const startIndex = (page - 1) * itemsPerPage;
//     const endIndex = startIndex + itemsPerPage;
//     return properties.slice(startIndex, endIndex);
//   };

//   // Handle page change
//   const handlePageChange = (event, value) => {
//     setPage(value);
//     // Scroll to top when changing pages
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//   };

//   // Function to format price with commas
//   const formatPrice = (price) => {
//     if (!price) return '0';
//     return '₹' + price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
//   };

//   // Function to get property image or placeholder
//   const getPropertyImage = (property) => {
//     if (!property.image) {
//       return 'https://via.placeholder.com/300x140?text=No+Image';
//     }

//     // Check if the image is already a full URL
//     if (property.image.startsWith('http')) {
//       return property.image;
//     }

//     // Check if the image is a base64 string with data URL prefix
//     if (property.image.startsWith('data:image/')) {
//       return property.image;
//     }

//     // Check if the image is a base64 string without prefix
//     if (property.image.startsWith('/9j/') || // JPEG
//         property.image.startsWith('iVBOR') || // PNG
//         property.image.startsWith('R0lGOD') || // GIF
//         property.image.startsWith('UE5HDQ') || // WebP
//         property.image.length > 1000) { // Likely base64 if long
//       return `data:image/jpeg;base64,${property.image}`;
//     }

//     // If it starts with / but doesn't seem to be base64, it might be a relative path
//     if (property.image.startsWith('/')) {
//       return `https://propertydealstalk.com${property.image}`;
//     }

//     // Fallback to placeholder
//     return 'https://via.placeholder.com/300x140?text=No+Image';
//   };

//   // Function to handle navigation to property details
//   const handlePropertyClick = (propertyId) => {
//     navigate(`/view/${propertyId}`);
//   };

//   if (loading) return <Loader />;

//   return (
//     <Box
//       sx={{
//         background: '#fff',
//         borderRadius: '16px',
//         width: '100%',
//         maxWidth: '1100px',
//         p: { xs: '16px', md: '24px' },
//         boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
//         mb: '24px',
//         boxSizing: 'border-box',
//         overflowX: 'hidden',
//       }}
//     >
//       {error ? (
//         <Box sx={{ textAlign: 'center', p: 3 }}>
//           <Typography color="error">{error}</Typography>
//         </Box>
//       ) : properties.length === 0 ? (
//         <Box sx={{ textAlign: 'center', p: 3 }}>
//           <Typography>No recent searches found.</Typography>
//         </Box>
//       ) : (
//         <>
//           <Box
//             sx={{
//               display: 'flex',
//               flexDirection: 'column',
//               gap: '30px',
//             }}
//           >
//             {getCurrentPageItems().map((property) => (
//               <Box
//                 key={property.id}
//                 sx={{
//                   display: 'flex',
//                   flexDirection: { xs: 'column', md: 'row' },
//                   background: '#fff',
//                   border: '1px solid #ddd',
//                   borderRadius: '12px',
//                   overflow: 'hidden',
//                   height: { md: '140px', xs: 'auto' },
//                   width: '100%',
//                   cursor: 'pointer',
//                   transition: 'transform 0.2s, box-shadow 0.2s',
//                   '&:hover': {
//                     transform: 'translateY(-2px)',
//                     boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
//                   },
//                 }}
//                 onClick={() => handlePropertyClick(property.id)}
//               >
//                 <Box
//                   component="img"
//                   src={getPropertyImage(property)}
//                   alt={property.property_name || 'Property Image'}
//                   sx={{
//                     width: { md: '300px', xs: '100%' },
//                     height: { md: '140px', xs: '180px' },
//                     objectFit: 'cover',
//                     flexShrink: 0,
//                     borderTopLeftRadius: { md: '8px', xs: 0 },
//                     borderBottomLeftRadius: { md: '8px', xs: 0 },
//                   }}
//                   onError={(e) => {
//                     e.target.src = 'https://via.placeholder.com/300x140?text=No+Image';
//                   }}
//                 />
//                 <Box
//                   sx={{
//                     flex: 1,
//                     ml: { md: '20px', xs: 0 },
//                     p: { xs: '16px', md: '10px' },
//                     display: 'flex',
//                     flexDirection: 'column',
//                   }}
//                 >
//                   <Box
//                     sx={{
//                       display: 'flex',
//                       justifyContent: 'space-between',
//                       alignItems: 'flex-start',
//                     }}
//                   >
//                     <Box>
//                       <h3 style={{ margin: 0, fontSize: '18px', fontWeight: 600 }}>
//                         {property.property_name || 'Unnamed Property'}
//                       </h3>
//                       <p
//                         style={{
//                           color: '#2563EB',
//                           fontWeight: 600,
//                           margin: '5px 0',
//                         }}
//                       >
//                         {formatPrice(property.asking_price)}
//                       </p>
//                       <p
//                         style={{
//                           color: '#555',
//                           fontSize: '14px',
//                           marginBottom: '11px',
//                         }}
//                       >
//                         {property.area_name || ''}{property.area_name && property.location ? ', ' : ''}{property.location || ''}
//                       </p>
//                       <p
//                         style={{
//                           color: '#555',
//                           fontSize: '14px',
//                           marginTop: 0,
//                         }}
//                       >
//                         {property.property_type === 'residential' ? 'Residential' : 'Commercial'} {property.asset_type || ''}
//                       </p>
//                     </Box>
//                     <Box
//                       sx={{
//                         display: 'flex',
//                         gap: '10px',
//                         flexWrap: { xs: 'wrap', md: 'nowrap' },
//                       }}
//                       onClick={(e) => e.stopPropagation()} // Prevent navigation when clicking buttons
//                     >
//                       <button
//                         style={{
//                           display: 'flex',
//                           alignItems: 'center',
//                           gap: '8px',
//                           background: 'none',
//                           border: 'none',
//                           fontWeight: 500,
//                           cursor: 'pointer',
//                         }}
//                       >
//                         <img
//                           src={saveIcon}
//                           alt="Save"
//                           style={{ width: '98px', height: '36px' }}
//                         />
//                       </button>
//                       <button
//                         style={{
//                           display: 'flex',
//                           alignItems: 'center',
//                           gap: '8px',
//                           background: 'none',
//                           border: 'none',
//                           fontWeight: 500,
//                           cursor: 'pointer',
//                         }}
//                       >
//                         <img
//                           src={shareIcon}
//                           alt="Share"
//                           style={{ width: '98px', height: '36px' }}
//                         />
//                       </button>
//                     </Box>
//                   </Box>
//                   <Box
//                     sx={{
//                       display: 'flex',
//                       gap: { md: '120px', xs: '12px' },
//                       flexDirection: { xs: 'column', md: 'row' },
//                       flexWrap: { xs: 'wrap', md: 'nowrap' },
//                       mt: { md: '5px', xs: '10px' },
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: '6px',
//                       }}
//                     >
//                       {/* <img src={bedIcon} alt="Beds" /> */}
//                       <span>{property.bhk || '-'} BHK</span>
//                     </Box>
//                     <Box
//                       sx={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: '6px',
//                       }}
//                     >
//                       {/* <img src={bathIcon} alt="Baths" /> */}
//                       <span>{property.furnish_type || '-'}</span>
//                     </Box>
//                     <Box
//                       sx={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: '6px',
//                       }}
//                     >
//                       {/* <img src={areaIcon} alt="Area" /> */}
//                       <span>{property.property_size || '-'} {property.property_size_units || 'sq.ft'}</span>
//                     </Box>
//                   </Box>
//                 </Box>
//               </Box>
//             ))}
//           </Box>
         
//           {/* Pagination component - only show if we have more than one page */}
//           {totalPages > 1 && (
//             <Box sx={{ 
//               display: 'flex', 
//               justifyContent: 'center', 
//               mt: 4,
//               width: '100%'
//             }}>
//               <Pagination 
//                 count={totalPages} 
//                 page={page} 
//                 onChange={handlePageChange}
//                 color="primary"
//                 size="medium"
//                 showFirstButton
//                 showLastButton
//                 sx={{
//                   '& .MuiPaginationItem-root': {
//                     color: '#333',
//                   },
//                   '& .Mui-selected': {
//                     backgroundColor: '#2563EB !important',
//                     color: 'white',
//                   }
//                 }}
//               />
//             </Box>
//           )}
//         </>
//       )}
//     </Box>
//   );
// };

// export default PropertiesSearched;


import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Pagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  InputAdornment,
  Snackbar,
  Alert,
  IconButton,
  useMediaQuery,
  useTheme,
  Button,
} from '@mui/material';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../Commonlibs/userSlice';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CloseIcon from '@mui/icons-material/Close';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import ShareIcon from '@mui/icons-material/Share';
// Import loader
import Loader from '../../../Loader/Loader';

const outfitFontStyle = {
  fontFamily: 'Outfit, sans-serif',
};

const PropertiesSearched = () => {
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Pagination states
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const itemsPerPage = 3;

  // Share dialog states
  const [shareDialog, setShareDialog] = useState(false);
  const [shareUrl, setShareUrl] = useState('');
  const [selectedPropertyId, setSelectedPropertyId] = useState(null);

  // Favorites state
  const [favorites, setFavorites] = useState({});

  // Toast notification state
  const [toast, setToast] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  const navigate = useNavigate();
  const user = useSelector(selectUser);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isLoggedIn = !!user?.token;
  
  useEffect(() => {
    const fetchSearchedProperties = async () => {
      try {
        setLoading(true);
        const buyer_id = user?.id || 2;
       
        const response = await axios.get(
          `https://propertydealstalk.com/api/buyerAnalytics/getBuyerDashboardPropertiesByType?buyer_id=${buyer_id}&type=recently_searched`
        );
       
        if (response.data.statusCode === 200 && response.data.status === "SUCCESS") {
          const allProperties = response.data.result || [];
          setProperties(allProperties);
          
          const calculatedPages = Math.ceil(allProperties.length / itemsPerPage);
          setTotalPages(calculatedPages);
          setPage(1);

          // Check favorite status for all properties
          if (isLoggedIn && user?.id) {
            checkAllFavoriteStatus(allProperties);
          }
        } else {
          setError(response.data.message || "Failed to fetch properties");
        }
      } catch (err) {
        setError("Error fetching searched properties");
        console.error("Error fetching searched properties:", err);
      } finally {
        setLoading(false);
      }
    };
    
    fetchSearchedProperties();
  }, [user, isLoggedIn]);

  // Check favorite status for all properties
  const checkAllFavoriteStatus = async (propertiesToCheck) => {
    if (!isLoggedIn || !user?.id) {
      return;
    }

    try {
      const response = await fetch(
        `https://propertydealstalk.com/api/buyer/getFavoritesByBuyerId?buyer_id=${user.id}`
      );
      const data = await response.json();

      if (data.statusCode === 200 && data.result) {
        const favoritesList = Array.isArray(data.result) ? data.result : [];
        const favoritesMap = {};
        
        propertiesToCheck.forEach(property => {
          const isInFavorites = favoritesList.some(
            fav => fav.property?.id === parseInt(property.id) || fav.property_id === parseInt(property.id)
          );
          favoritesMap[property.id] = isInFavorites;
        });
        
        setFavorites(favoritesMap);
        console.log('✅ Favorites checked:', favoritesMap);
      }
    } catch (err) {
      console.error('Error checking favorite status:', err);
    }
  };

  // Toggle favorite
  const toggleFavorite = async (e, property) => {
    e.stopPropagation();
    
    if (!isLoggedIn) {
      navigate('/login');
      return;
    }

    const propertyId = property.id;
    const isFavorite = favorites[propertyId] || false;

    try {
      if (isFavorite) {
        const response = await fetch('https://www.propertydealstalk.com/api/buyer/removeFavorite', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            buyer_id: user?.id,
            property_id: parseInt(propertyId)
          })
        });

        const data = await response.json();

        if (data.statusCode === 200) {
          setFavorites(prev => ({ ...prev, [propertyId]: false }));
          setToast({
            open: true,
            message: 'Property removed from favorites successfully',
            severity: 'success'
          });
        } else {
          throw new Error(data.message || 'Failed to remove property from favorites');
        }
      } else {
        const response = await fetch('https://propertydealstalk.com/api/buyer/addFavorites', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            buyer_id: user?.id,
            property_id: parseInt(propertyId)
          })
        });

        const data = await response.json();

        if (data.statusCode === 200) {
          setFavorites(prev => ({ ...prev, [propertyId]: true }));
          setToast({
            open: true,
            message: 'Property added to favorites successfully',
            severity: 'success'
          });
        } else {
          throw new Error(data.message || 'Failed to add property to favorites');
        }
      }
    } catch (err) {
      console.error('Error toggling favorite:', err);
      setToast({
        open: true,
        message: err.message || 'Failed to update favorites',
        severity: 'error'
      });
    }
  };

  // Get current page items
  const getCurrentPageItems = () => {
    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return properties.slice(startIndex, endIndex);
  };

  // Handle page change
  const handlePageChange = (event, value) => {
    setPage(value);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Format price
  const formatPrice = (price) => {
    if (!price) return '0';
    return '₹' + price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  // Get property image
  const getPropertyImage = (property) => {
    if (!property.image) {
      return 'https://via.placeholder.com/300x140?text=No+Image';
    }

    if (property.image.startsWith('http')) {
      return property.image;
    }

    if (property.image.startsWith('data:image/')) {
      return property.image;
    }

    if (property.image.startsWith('/9j/') || 
        property.image.startsWith('iVBOR') || 
        property.image.startsWith('R0lGOD') || 
        property.image.startsWith('UE5HDQ') || 
        property.image.length > 1000) {
      return `data:image/jpeg;base64,${property.image}`;
    }

    if (property.image.startsWith('/')) {
      return `https://propertydealstalk.com${property.image}`;
    }

    return 'https://via.placeholder.com/300x140?text=No+Image';
  };

  // Handle property click
  const handlePropertyClick = (propertyId) => {
    navigate(`/view/${propertyId}`);
  };

  // Share handlers
  const handleShareClick = async (e, property) => {
    e.stopPropagation();
    const publicUrl = `${window.location.origin}/view/${property.id}`;
    
    const shareData = {
      title: property?.property_name || 'Property on PropertyDealsTalk',
      text: `Check out ${property?.property_name || 'this property'} - ${formatPrice(property?.asking_price)} at ${property?.location || 'prime location'}`,
      url: publicUrl
    };

    if (navigator.share && navigator.canShare && navigator.canShare(shareData)) {
      try {
        await navigator.share(shareData);
        setToast({
          open: true,
          message: 'Shared successfully!',
          severity: 'success'
        });
      } catch (err) {
        if (err.name !== 'AbortError') {
          setShareUrl(publicUrl);
          setSelectedPropertyId(property.id);
          setShareDialog(true);
        }
      }
    } else {
      setShareUrl(publicUrl);
      setSelectedPropertyId(property.id);
      setShareDialog(true);
    }
  };

  const handleCopyUrl = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setToast({
        open: true,
        message: 'URL copied to clipboard!',
        severity: 'success'
      });
    } catch (err) {
      setToast({
        open: true,
        message: 'Failed to copy URL',
        severity: 'error'
      });
    }
  };

  const handleCloseShareDialog = () => {
    setShareDialog(false);
    setSelectedPropertyId(null);
  };

  const handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') return;
    setToast(prev => ({ ...prev, open: false }));
  };

  if (loading) return <Loader />;

  return (
    <Box
      sx={{
        background: '#fff',
        borderRadius: '16px',
        width: '100%',
        maxWidth: '1100px',
        p: { xs: '16px', md: '24px' },
        boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
        mb: '24px',
        boxSizing: 'border-box',
        overflowX: 'hidden',
      }}
    >
      {error ? (
        <Box sx={{ textAlign: 'center', p: 3 }}>
          <Typography color="error">{error}</Typography>
        </Box>
      ) : properties.length === 0 ? (
        <Box sx={{ textAlign: 'center', p: 3 }}>
          <Typography>No recent searches found.</Typography>
        </Box>
      ) : (
        <>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '30px',
            }}
          >
            {getCurrentPageItems().map((property) => {
              const isFavorite = favorites[property.id] || false;

              return (
                <Box
                  key={property.id}
                  sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    background: '#fff',
                    border: '1px solid #ddd',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    height: { md: '140px', xs: 'auto' },
                    width: '100%',
                    cursor: 'pointer',
                    transition: 'transform 0.2s, box-shadow 0.2s',
                    '&:hover': {
                      transform: 'translateY(-2px)',
                      boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                    },
                  }}
                  onClick={() => handlePropertyClick(property.id)}
                >
                  <Box
                    component="img"
                    src={getPropertyImage(property)}
                    alt={property.property_name || 'Property Image'}
                    sx={{
                      width: { md: '300px', xs: '100%' },
                      height: { md: '140px', xs: '180px' },
                      objectFit: 'cover',
                      flexShrink: 0,
                      borderTopLeftRadius: { md: '8px', xs: 0 },
                      borderBottomLeftRadius: { md: '8px', xs: 0 },
                    }}
                    onError={(e) => {
                      e.target.src = 'https://via.placeholder.com/300x140?text=No+Image';
                    }}
                  />
                  <Box
                    sx={{
                      flex: 1,
                      ml: { md: '20px', xs: 0 },
                      p: { xs: '16px', md: '10px' },
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        mb: 1,
                      }}
                    >
                      <Box sx={{ flex: 1 }}>
                        <Typography
                          variant="h6"
                          sx={{
                            ...outfitFontStyle,
                            fontWeight: 600,
                            fontSize: '18px',
                            mb: 0.5,
                            margin: 0,
                          }}
                        >
                          {property.property_name || 'Unnamed Property'}
                        </Typography>
                        <Typography
                          sx={{
                            ...outfitFontStyle,
                            color: '#2563EB',
                            fontWeight: 700,
                            fontSize: '18px',
                            margin: '5px 0',
                          }}
                        >
                          {formatPrice(property.asking_price)}
                        </Typography>
                        <Typography
                          sx={{
                            ...outfitFontStyle,
                            color: '#6b7280',
                            fontSize: '14px',
                            marginBottom: '11px',
                          }}
                        >
                          {property.area_name || ''}{property.area_name && property.location ? ', ' : ''}{property.location || ''}
                        </Typography>
                        <Typography
                          sx={{
                            ...outfitFontStyle,
                            color: '#6b7280',
                            fontSize: '14px',
                            marginTop: 0,
                          }}
                        >
                          {property.property_type === 'residential' ? 'Residential' : 'Commercial'} {property.asset_type || ''}
                        </Typography>
                      </Box>

                      {/* Save and Share Buttons - TalkView Style */}
                      <Box
                        sx={{
                          display: 'flex',
                          gap: 3,
                          ml: 2,
                          alignItems: 'center',
                        }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        {/* Save Button */}
                        <Box
                          display="flex"
                          alignItems="center"
                          gap={1}
                          sx={{ cursor: 'pointer' }}
                          onClick={(e) => toggleFavorite(e, property)}
                        >
                          {isFavorite ? (
                            <FavoriteIcon sx={{ color: 'red', fontSize: 32 }} />
                          ) : (
                            <FavoriteBorderIcon sx={{ color: '#666', fontSize: 32 }} />
                          )}
                          <Typography fontSize={14} fontWeight={500} color="#000" sx={outfitFontStyle}>
                            {isFavorite ? 'Saved' : 'Save'}
                          </Typography>
                        </Box>

                        {/* Share Button */}
                        <Box
                          display="flex"
                          alignItems="center"
                          gap={1}
                          sx={{ cursor: 'pointer' }}
                          onClick={(e) => handleShareClick(e, property)}
                        >
                          <ShareIcon sx={{ color: '#666', fontSize: 28 }} />
                          <Typography fontSize={14} fontWeight={500} color="#000" sx={outfitFontStyle}>
                            Share
                          </Typography>
                        </Box>
                      </Box>
                    </Box>

                    {/* Property Details - HIDDEN on Mobile, NOT SHOWING on Desktop */}
                    {/* Removed completely as requested */}
                  </Box>
                </Box>
              );
            })}
          </Box>
         
          {/* Pagination */}
          {totalPages > 1 && (
            <Box sx={{ 
              display: 'flex', 
              justifyContent: 'center', 
              mt: 4,
              width: '100%'
            }}>
              <Pagination 
                count={totalPages} 
                page={page} 
                onChange={handlePageChange}
                color="primary"
                size="medium"
                showFirstButton
                showLastButton
                sx={{
                  '& .MuiPaginationItem-root': {
                    ...outfitFontStyle,
                    color: '#333',
                  },
                  '& .Mui-selected': {
                    backgroundColor: '#2563EB !important',
                    color: 'white',
                  }
                }}
              />
            </Box>
          )}
        </>
      )}

      {/* Share Dialog */}
      <Dialog open={shareDialog} onClose={handleCloseShareDialog} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6" fontWeight={600} sx={outfitFontStyle}>
            Share Property
          </Typography>
          <IconButton onClick={handleCloseShareDialog} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="#666" mb={2} sx={outfitFontStyle}>
            Share this property link with others. Anyone with this link can view the property details.
          </Typography>
          <TextField
            fullWidth
            value={shareUrl}
            InputProps={{
              readOnly: true,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleCopyUrl} edge="end" color="primary" title="Copy URL">
                    <ContentCopyIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            sx={{ 
              '& .MuiOutlinedInput-root': { 
                backgroundColor: '#f5f5f5',
                ...outfitFontStyle 
              } 
            }}
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button 
            onClick={handleCloseShareDialog} 
            variant="outlined" 
            sx={outfitFontStyle}
          >
            Close
          </Button>
          <Button 
            onClick={handleCopyUrl} 
            variant="contained" 
            startIcon={<ContentCopyIcon />} 
            sx={outfitFontStyle}
          >
            Copy Link
          </Button>
        </DialogActions>
      </Dialog>

      {/* Toast Notifications */}
      <Snackbar
        open={toast.open}
        autoHideDuration={6000}
        onClose={handleCloseToast}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseToast} severity={toast.severity} sx={{ width: '100%', ...outfitFontStyle }}>
          {toast.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default PropertiesSearched;
